import { compose, withHandlers, withState, branch, renderNothing } from 'recompose';

export default compose(
  withState('isOpen', 'setIsOpen', false),
  withState('tooltipPos', 'setTooltipPos', { top: 0, left: 0 }),
  withHandlers({
    handleMouseLeave: props => () => props.setIsOpen(false),
    handleMouseEnter: props => (e) => {
      props.setIsOpen(true);

      const parentPos = e.target.getBoundingClientRect();
      props.setTooltipPos({ top: Math.max(parentPos.top, 20) - 20, left: parentPos.right || 0 });
    },
  }),
  branch(
    ({ text, children }) => (!text || (typeof text !== 'string' && !text.trim().length)) && !children,
    renderNothing,
  ),
);
